import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Star } from 'lucide-react';

const GoogleReviewBadge = () => {
  const { language } = useLanguage();

  return (
    <a
      href="https://www.google.com/maps/place/Sakthi+Hospital/@13.0570045,80.2757397,17z/data=!4m8!3m7!1s0x3a526605d0a030d5:0x6e079bd99529d311"
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 left-6 z-40 bg-white rounded-xl shadow-lg border border-gray-100 px-4 py-3 flex items-center gap-3 hover:shadow-xl transition-shadow group"
      data-testid="google-review-badge"
    >
      {/* Google Logo */}
      <svg className="w-6 h-6 flex-shrink-0" viewBox="0 0 24 24">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
      </svg>
      <div>
        <div className="flex items-center gap-1">
          <span className="text-lg font-bold text-[#0f172a]">4.2</span>
          <div className="flex gap-0.5">
            {[1,2,3,4].map(i => <Star key={i} size={12} fill="#FBBC05" stroke="#FBBC05" />)}
            <Star size={12} fill="none" stroke="#FBBC05" strokeWidth={2} />
          </div>
        </div>
        <div className="text-[10px] text-[#64748b] group-hover:text-[#0066b3] transition-colors">
          {language === 'ta' ? '800+ Google மதிப்புரைகள்' : '800+ Google Reviews'}
        </div>
      </div>
    </a>
  );
};

export default GoogleReviewBadge;
